<div class="new-item">
	<app-barcode (barcodeRegister)="barcodeRegistered($event)" *ngIf="state == newItemStates.Barcode"></app-barcode>
	<input class="item-name" type="text" [(ngModel)]="item.name" placeholder="Item" *ngIf="state == newItemStates.Picture" />
	<app-camera (pictureTaken)="pictureTaken($event)" *ngIf="state == newItemStates.Picture"></app-camera>
	<app-price-input (priceResult)="itemSubmitted($event)" *ngIf="state == newItemStates.Picture"></app-price-input>
</div>
<img src="/assets/register.webp" class='register-link' (click)="registerClick()">